'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { EVENT_CATEGORIES, type EventCategory } from '@/lib/eventCategories';

export default function CategoryChips({
  active,
}: {
  active: EventCategory | null;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const sp = useSearchParams();

  const navigate = (next: EventCategory | null) => {
    const params = new URLSearchParams(sp.toString());
    // フィルタ変更時はページ番号をリセット（空ページになりにくくする）
    params.delete('page');
    if (!next) {
      params.delete('category');
    } else {
      params.set('category', next);
    }
    const url = `${pathname}${params.toString() ? `?${params.toString()}` : ''}`;
    router.push(url);
    router.refresh();
  };

  const chipCls = (isActive: boolean) =>
    `inline-flex h-9 shrink-0 items-center justify-center whitespace-nowrap rounded-full px-4 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white ${
      isActive
        ? 'bg-primary text-white'
        : 'border border-secondary bg-white text-secondary'
    }`;

  return (
    <div className='flex flex-col items-center'>
      <div className='flex flex-wrap items-center justify-center gap-2 md:gap-3'>
        <button
          aria-current={!active ? 'page' : undefined}
          onClick={() => navigate(null)}
          className={chipCls(!active)}
        >
          全カテゴリ
        </button>
        {EVENT_CATEGORIES.map((c) => (
          <button
            key={c}
            aria-current={active === c ? 'page' : undefined}
            onClick={() => navigate(c)}
            className={chipCls(active === c)}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  );
}

